<template>
	<div
		class="floating-panel"
		:class="{...classes}"
	>
		<div class="floating-panel--content">
			<!-- header -->
			<div class="floating-panel--header">
				<div class="floating-panel--title">
					<h2>{{ title }}</h2>
					<div
						class="button-close"
						@click="close"
					>
						<Icon
							icon-name="e-remove"
							size="lg"
						/>
					</div>
				</div>
				<div class="floating-panel--subtitle">
					<slot name="subtitle" />
				</div>
			</div>
			<!-- end header -->

			<!-- body -->
			<div class="floating-panel--body">
				<slot name="body" />
			</div>
			<!-- end body -->

			<!-- footer -->
			<div class="floating-panel--footer">
				<slot name="footer" />
			</div>
			<!-- end footer -->
		</div>
		<div class="floating-panel--overlay">
			<slot name="footer-overlay" />
		</div>
	</div>
</template>

<script>
export default {
	name:  'FloatingPanel',
	props: {
		classes: {
			type:    Object,
			default: () => {},
		},
		title: {
			type: String,
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.floating-panel {
	height: 100%;
	background: var(--color-grey-900);
	position: relative;
}

.floating-panel--content {
	padding: 24px;
	display: flex;
	flex-direction: column;
	height: 100%;

	@include size(sm-down) {
		min-height: 100%;
		padding: 16px;
	}

	.floating-panel--header {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding-bottom: 24px;

		@include size(sm-down) {
			flex: 0 0 auto;
		}

		.floating-panel--title {
			display: flex;
			justify-content: space-between;
			margin-bottom: 27px;
		}
	}

	.floating-panel--body {
		flex: 1 1 auto;
		overflow: auto;
	}

	.floating-panel--footer {
		@include size(sm-down) {
			flex: 0 0 auto;
			width: 100%;
			background: var(--color-grey-900);
			margin-top: 16px;
		}
	}
}

.floating-panel--overlay {
	position: absolute;
	bottom: 0;
	width: 100%;

	@include size(sm-down) {
		position: fixed;
	}
}

.button-close {
	display: flex;
	align-items: center;
	cursor: pointer;
}
</style>
